import API from '../lib/api';
import SwipeUI from '../lib/ui/swipe_ui';
import toastr from 'toastr';

const THEME_MODAL_ID_PREFIX = "theme-modal-";

export function toggleCustomModal(id = '', visible = undefined) {
  const modal = document.getElementById(`${id}`);
  if (!modal) return;

  if (visible === undefined) visible = modal.classList.contains('hide');
  if (visible) modal.classList.remove('hide');
  else modal.classList.add('hide');

  // For iOS
  window.webkit?.messageHandlers?.setDarkTheme?.postMessage(visible ? 'true' : 'false');
}

export function toggleModal(index, visible = undefined) {
  const modal = document.getElementById(`${THEME_MODAL_ID_PREFIX}${index}`);
  if (!modal) return;

  if (visible === undefined) visible = modal.classList.contains('hide');
  if (visible) modal.classList.remove('hide');
  else modal.classList.add('hide');

  // For iOS
  window.webkit?.messageHandlers?.setDarkTheme?.postMessage(visible ? 'true' : 'false');
}

let isRequesting = false;

function startGame(themeId, superThemeId = '') {
  if (isRequesting) return;
  isRequesting = true;

  API.plays.theme
    .withId(themeId)
    .call({
      play_mode: 'solo'
    })
    .then(res => {
      // console.log(res.data?.url);
      window.kp?.purchase(superThemeId);
      redirectTo(res.data?.url);
    })
    .catch(err => {
      toastr.error(err.message);
    })
    .finally(() => {
      isRequesting = false;
    });
}

function initKLeagueModal() {
  // K리그 관련
  const kLeagueModal = document.querySelector('#k-league-team-modal');
  if (!kLeagueModal) return;

  function currentTeam() {
    const item = kLeagueModal?.querySelector('.k-team.selected');
    return item?.dataset?.title;
  }

  const btn = kLeagueModal.querySelector('.confirm-team');
  btn?.addEventListener('click', e => {
    if (btn.isRequesting) return;
    btn.isRequesting = true;
    const themeId = btn.dataset.themeId;
    API.themes.custom
      .withId(themeId)
      .call({
        type: 'set_team',
        value: currentTeam()
      })
      .then(res => {
        toastr.success('팀 설정 성공!');
        redirectTo(undefined, true);
      })
      .catch(e => {
        toastr.error('팀 설정에 실패하였습니다.');
      })
      .finally(() => {
        e.isRequesting = false;
      });
  });
  const items = kLeagueModal.querySelectorAll('.k-team');
  for (const item of items) {
    item.addEventListener('click', e => {
      for (const item2 of items) item2.classList.remove('selected');
      item.classList.add('selected');
    });
  }
}

onload(() => {
  $('.close-modal').each((i, e) => {
    $(e).on('click', evt => {
      if ($(e).data('modal-id'))
        toggleCustomModal($(e).data('modal-id'), false);
      else
        toggleModal($(e).data('index'), false);
    });
  });

  // 게임 시작
  $('.start-game').each((i, e) => {
    $(e).on('click', evt => {
      startGame($(e).data('theme-id'), $(e).data('super-theme-id'));
    });
  });

  // https://codepen.io/warrino/pen/yOybaB?editors=1010
  for(const modal of document.querySelectorAll('.ptw-modal.themes-modal')) {
    new SwipeUI({
      target: modal,
      onSwipe(s) {
        const dY = Math.floor(-s.dY + s.dT);
        if (dY > 0) return;
  
        const transform = `translateY(${-dY}px)`;
        modal.styles = {
          '-webkit-transform': transform,
          'transform': transform,
          '-webkit-transition': 'transform ' + 0 + 'ms',
          'transition': 'transform ' + 0 + 'ms',
          '-webktit-backface-visibility': 'hidden',
          'backface-visibility': 'hidden'
        };
      },
      onEnd(s) {
        modal.styles = {
          '-webkit-transform': null,
          'transform': null,
          '-webkit-transition': null,
          'transition': null,
          '-webktit-backface-visibility': null,
          'backface-visibility': null
        };
  
        const dY = Math.floor(-s.dY + s.dT);
        if (-dY > 300) toggleModal(modal.dataset.index, false);
      }
    });
  }

  initKLeagueModal();
});